module.exports = __webpack_public_path__ + "assets/img/BG UNG.b5f52ec5.png";